import { AdjustmentFilter, ColorOverlayFilter } from 'pixi-filters';
import type { ColorSource, Container } from 'pixi.js';
import type { EasingFunction, EasingMap } from '../../../libs/TweenManager/easing';
import { Easing } from '../../../libs/TweenManager/easing';
import type { Tween } from '../../../libs/TweenManager/Tween';
import { findOrCreateFilter, removeFilter } from '../filter-utils';

export function animateBrightnessFlash(
  container: Container,
  brightness = 1.25,
  duration = 333,
  ease: EasingFunction | keyof typeof EasingMap | null = Easing.Default,
  delay = 0,
): Tween {
  const filter = findOrCreateFilter(container, AdjustmentFilter, () => new AdjustmentFilter());
  filter.brightness = 1;

  const tween = container.tweenCreate(filter).to({ brightness }, duration, ease, true, delay, undefined, true);

  void tween.asyncOnComplete().then(() => {
    removeFilter(container, filter);
  });

  return tween;
}

export function animateBrightnessTo(
  container: Container,
  brightness = 2,
  duration = 333,
  ease: EasingFunction | keyof typeof EasingMap | null = Easing.Default,
  delay = 0,
  repeat = 0,
  yoyo = false,
): Tween {
  const filter: AdjustmentFilter = findOrCreateFilter(container, AdjustmentFilter, () => new AdjustmentFilter());
  return container.tweenCreate(filter).to({ brightness }, duration, ease, true, delay, repeat, yoyo);
}

export function animateColorTo(
  container: Container,
  color: ColorSource,
  fromAlpha: number,
  toAlpha: number,
  duration = 333,
  ease: EasingFunction | keyof typeof EasingMap | null = Easing.Default,
  delay = 0,
  repeat = 0,
  yoyo = false,
): Tween {
  const filter: ColorOverlayFilter = findOrCreateFilter(container, ColorOverlayFilter, () => new ColorOverlayFilter());
  filter.color = color;
  filter.alpha = fromAlpha;

  return container.tweenCreate(filter).to({ alpha: toAlpha }, duration, ease, true, delay, repeat, yoyo);
}
